module.exports = __webpack_public_path__ + "static/media/refer_icon.b8f146f3.svg";